<template>
	<v-sheet flat class="mt-12">
		<v-card
			color="lightest"
			text
			class="mt-3 rounded-lg"
			flat
		>
			<v-card-text>
				<v-form v-if="!sent">
					<v-text-field
						:label="$t('contact_form.email')"
						v-model="email"
					></v-text-field>
					<v-textarea
						:label="$t('contact_form.message')"
						v-model="message"
					></v-textarea>
					<p class="text-right">
						<v-btn color="primary" @click="submit" icon x-large>
							<v-icon>mdi-send-circle</v-icon>
						</v-btn>
					</p>
				</v-form>
				<v-alert color="lightest" v-else>
					{{ $t("contact_form.after_send") }}
				</v-alert>
			</v-card-text>
		</v-card>
	</v-sheet>
</template>

<script>
export default {
	name: "ContactForm",
	data: () => ({
		sent: false,
		email: "",
		message: "",
	}),
	computed: {
		auth() {
			return this.$store.state.auth.data;
		},
	},
	watch: {
		auth: {
			immediate: true,
			handler() {
				let email = this.auth.email;
				if (email) {
					this.email = email;
				}
			},
		},
	},
	methods: {
		submit() {
			const self = this;
			self.$store
				.dispatch("emails/contactForm", {
					email: self.email,
					message: self.message,
				})
				.then(() => {
					self.sent = true;
				});
		},
	},
};
</script>
